const focusByNames = (names: string[]) => {
    const elements: {element: HTMLElement; top: number}[] = [];
    names.forEach((name) => {
        const element = document.getElementsByName(name)[0];
        if (element) {
            elements.push({
                element,
                top: element.getBoundingClientRect().top,
            });
        }
    });

    const element = elements.sort((a, b) => a.top - b.top).shift()?.element;

    if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'center'});
        element.focus({preventScroll: true});
        return true;
    }
    return false;
};
export default focusByNames;
